import { X, Check } from "lucide-react";
import shattaraLogo from "@/assets/shattara-ai-comparison-logo.png";

export const Comparison = () => {
  return (
    <section className="w-full py-24 px-6 md:px-10">
      <div className="container mx-auto max-w-[68.75rem] px-5">
        <div className="flex flex-col gap-8">
          {/* Header */}
          <div className="flex flex-col gap-4">
            <h2 className="text-4xl md:text-5xl text-foreground font-medium lg:text-6xl text-center">
              Shattara Is the Only App Built Purely for Students
            </h2>
            <p className="text-sm md:text-base text-muted-foreground text-center">
              Unlike other tools, Shattara is designed for students -<br className="hidden sm:block" />
              and has everything you need.
            </p>
          </div>

          {/* Comparison Table Container */}
          <div className="flex flex-col items-center justify-center gap-8">
            {/* Scrollable wrapper for mobile */}
            <div className="w-full overflow-x-auto pb-8 md:overflow-visible">
              <div className="min-w-[700px] md:min-w-0">
                {/* Grid Table */}
                <div className="grid grid-cols-6 gap-4 md:gap-8 auto-rows-auto text-xs md:text-sm">
                  {/* Header Row */}
                  <div className="font-bold text-foreground">Features</div>
                  <div className="flex items-center justify-center">
                    <img
                      src={shattaraLogo}
                      alt="Shattara AI"
                      className="h-6 md:h-8 w-auto object-contain" />

                  </div>
                  <div className="font-bold justify-self-center text-foreground">NotebookLM</div>
                  <div className="font-bold justify-self-center text-foreground">ChatGPT</div>
                  <div className="font-bold justify-self-center text-foreground">Quizlet</div>
                  <div className="font-bold justify-self-center text-foreground">Notion</div>

                  {/* Shared Notes */}
                  <div className="font-bold text-foreground">Shared Notes</div>
                  <div className="flex items-center justify-center">
                    <Check className="w-4 h-4 md:w-5 md:h-5 stroke-[hsl(var(--color-green))]" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <Check className="w-4 h-4 md:w-5 md:h-5 stroke-[hsl(var(--color-green))]" strokeWidth={2} />
                  </div>

                  {/* Quizzes / Flashcards */}
                  <div className="font-bold text-foreground">Quizzes / Flashcards</div>
                  <div className="flex items-center justify-center">
                    <Check className="w-4 h-4 md:w-5 md:h-5 stroke-[hsl(var(--color-green))]" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <Check className="w-4 h-4 md:w-5 md:h-5 stroke-[hsl(var(--color-green))]" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <Check className="w-4 h-4 md:w-5 md:h-5 stroke-[hsl(var(--color-green))]" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>

                  {/* Course Overview */}
                  <div className="font-bold text-foreground">Course Overview</div>
                  <div className="flex items-center justify-center">
                    <Check className="w-4 h-4 md:w-5 md:h-5 stroke-[hsl(var(--color-green))]" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>

                  {/* AI Chat */}
                  <div className="font-bold text-foreground">AI Chat</div>
                  <div className="flex items-center justify-center">
                    <Check className="w-4 h-4 md:w-5 md:h-5 stroke-[hsl(var(--color-green))]" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <Check className="w-4 h-4 md:w-5 md:h-5 stroke-[hsl(var(--color-green))]" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <Check className="w-4 h-4 md:w-5 md:h-5 stroke-[hsl(var(--color-green))]" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>

                  {/* Exam Simulator */}
                  <div className="font-bold text-foreground">Exam Simulator</div>
                  <div className="flex items-center justify-center">
                    <Check className="w-4 h-4 md:w-5 md:h-5 stroke-[hsl(var(--color-green))]" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <Check className="w-4 h-4 md:w-5 md:h-5 stroke-[hsl(var(--color-green))]" strokeWidth={2} />
                  </div>
                  <div className="flex items-center justify-center">
                    <X className="w-4 h-4 md:w-5 md:h-5 stroke-muted-foreground" strokeWidth={2} />
                  </div>

                  {/* Made for */}
                  <div className="font-bold text-foreground">Built for:</div>
                  <div className="text-center text-foreground">You (Student)</div>
                  <div className="text-center text-foreground">Researchers</div>
                  <div className="text-center text-foreground">Everyone</div>
                  <div className="text-center text-foreground">Students</div>
                  <div className="text-center text-foreground">Everyone</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};